import type { PricingVersionFormat, PricingVersionTuple } from '../../model/model.ts'

type NlAovqlPricingVersionFormat = PricingVersionFormat<'nl-aov-quantum-leben'>

export const nlAovqlPricingVersions = [
  ['pricing-nl-aov-quantum-leben-1.0.0-2026-08-13', { label: 'Version 1' }],
] as const satisfies PricingVersionTuple<NlAovqlPricingVersionFormat>[]

export type NlAovqlPricingVersion = (typeof nlAovqlPricingVersions)[number][0]
